<template>
  <div class="tags" v-if="showTags">
    <ul>
      <li
        class="tags-li"
        v-for="(item, index) in tagsList"
        :class="{ active: isActive(item.path) }"
        :key="index"
      >
        <router-link :to="item.path" class="tags-li-title">
          {{ lang === 'en' ? item.name : formatNames(item.name) || item.name }}
        </router-link>
        <span class="tags-li-icon" @click="closeTags(index)"><i class="el-icon-close"></i></span>
      </li>
    </ul>
    <!--<div class="tags-close-box">-->
    <!--<el-dropdown @command="handleTags">-->
    <!--<el-button size="mini" type="primary">-->
    <!--标签选项<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
    <!--</el-button>-->
    <!--<el-dropdown-menu size="small" slot="dropdown">-->
    <!--<el-dropdown-item command="other">关闭其他</el-dropdown-item>-->
    <!--<el-dropdown-item command="all">关闭所有</el-dropdown-item>-->
    <!--</el-dropdown-menu>-->
    <!--</el-dropdown>-->
    <!--</div>-->
  </div>
</template>

<script>
import { common } from '@/views/public/common'
import VueRouter from 'vue-router'

const { isNavigationFailure, NavigationFailureType } = VueRouter

export default {
  name: 'tagviews',
  data() {
    return {
      tagsList: []
    }
  },
  methods: {
    isActive(path) {
      return path === this.$route.fullPath
    },
    // 关闭单个标签
    closeTags(index) {
      const delItem = this.tagsList.splice(index, 1)[0]
      const item = this.tagsList[index] ? this.tagsList[index] : this.tagsList[index - 1]
      if (item) {
        delItem.path === this.$route.fullPath &&
          this.$router.push(item.path).catch(err => {
            // to hide the below error message
            if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
              throw Error(err)
            }
          })
      } else {
        // this.$router.push('/');
      }
    },
    // 关闭全部标签
    closeAll() {
      this.tagsList = []
      // this.$router.push('/');
    },
    // 关闭其他标签
    closeOther() {
      const curItem = this.tagsList.filter(item => {
        return item.path === this.$route.fullPath
      })
      this.tagsList = curItem
    },
    // 设置标签
    setTags(route) {
      const isExist = this.tagsList.some(item => {
        return item.path === route.fullPath
      })
      if (!isExist) {
        if (this.tagsList.length >= 8) {
          this.tagsList.shift()
        }
        this.tagsList.push({
          name: route.name,
          path: route.fullPath
        })
      }
    },
    handleTags(command) {
      command === 'other' ? this.closeOther() : this.closeAll()
    },
    formatNames: common.formatNames
  },
  computed: {
    showTags() {
      return this.tagsList.length > 0
    },
    visitedViews() {
      return this.tagsList
    },
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    $route(newValue, oldValue) {
      this.setTags(newValue)
      //   console.log(this.tagsList, 'tags')
    }
  },
  mounted() {
    this.setTags(this.$route)
    // 监听关闭当前页面的标签页
    // bus.$on('close_current_tags', () => {
    //     for (let i = 0, len = this.tagsList.length; i < len; i++) {
    //         const item = this.tagsList[i];
    //         if(item.path === this.$route.fullPath){
    //             if(i < len - 1){
    //                 this.$router.push(this.tagsList[i+1].path);
    //             }else if(i > 0){
    //                 this.$router.push(this.tagsList[i-1].path);
    //             }else{
    //                 this.$router.push('/');
    //             }
    //             this.tagsList.splice(i, 1);
    //             break;
    //         }
    //     }
    // })
  }
}
</script>

<style lang="scss" scoped>
.tags ul {
  box-sizing: border-box;
}

.tags-li {
  float: left;
  margin-right: 12px;
  @include border-radius(30px);
  font-size: 12px;
  overflow: hidden;
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  background: $white;
  padding: 0 12px;
  vertical-align: middle;
  color: rgba(143, 146, 158, 1);
  box-shadow: 0px 2px 4px 0px rgba(225, 225, 225, 1);
  -webkit-transition: all 0.3s ease-in;
  -moz-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
  border: 1px solid #eee;
}

.tags-li:not(.active):hover {
  background: #f8f8f8;
}

.tags-li.active {
  background: $primary-color;
  box-shadow: 0px 2px 4px 0px rgba(225, 225, 225, 1);
}

.tags-li-title {
  float: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 5px;
  color: rgba(143, 146, 158, 1);
  &:hover {
    text-decoration: none;
  }
}

.tags-li.active .tags-li-title,
.tags-li.active .el-icon-close {
  color: $white;
}

.tags-close-box {
  @include absolute-right-top(0, 0);
  box-sizing: border-box;
  padding-top: 1px;
  text-align: center;
  width: 110px;
  height: 30px;
  background: $white;
  box-shadow: -3px 0 15px 3px rgba(0, 0, 0, 0.1);
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/tagviews.vue